// extracted by mini-css-extract-plugin
module.exports = {"item":"ProductFrom_item__3EWlr"};